<!--
 * @Description: 附件预览

 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="preview-item-content">
    <!-- 链接为空 -->
    <template v-if="!getFileItem?.signedUrl && !getFileItem?.response?.data?.[0]?.url && !getFileItem?.url">
      <div class="invalid-content"></div>
    </template>
    <template v-else>
      <!-- 可预览的图片 -->
      <jw-image v-if="fileType('img')" width="100%" height="100%" target="_self" fit="cover" :src="setUrl(getFileItem, 1)" :class="['preview-hover', getFileItem?.name && getFileSuffix(getFileItem.name) == 'gif' ? 'gif-back-img' : '', props.showName ? 'height-80' : '']" @click.stop="openPreview()" :preview="grayList?.['FilePreview:preview'] ? true : false" />
      <!-- 可预览的视频 -->
      <jw-link :target="grayList?.['FilePreview:preview'] ? '_blank' : '_self'" :class="{ 'preview-hover': true, 'preview-link-content': true, 'height-80': props.showName }" :title="getFileItem?.name" :href="grayList?.['FilePreview:preview'] ? setUrl(getFileItem, 0) : 'javascript:void(0)'" v-else-if="fileType('video')" @click.stop="openPreview()">
        <!-- oss上传 -->
        <!-- <template v-if="!grayList?.['FileStorage:minioOss'] && (getFileItem?.response?.data?.[0]?.url || getFileItem?.url)">
          <img v-if="!grayList?.['FileStorage:minioOss']" class="object-fit-cover" :src="`${setUrl(getFileItem, 1)}?x-oss-process=video/snapshot,t_1000,f_jpg,w_900,m_fast`" :class="[props.showName ? 'height-80' : '']" @click.stop="openPreview()" />
        </template> -->

        <qf-icon-video :style="props.iconStyle" />
      </jw-link>
      <!-- 可预览的pdf -->
      <jw-link v-else-if="fileType('pdf')" :href="grayList?.['FilePreview:preview'] ? setUrl(getFileItem, 0) : 'javascript:void(0)'" :title="getFileItem?.name" :target="grayList?.['FilePreview:preview'] ? '_blank' : '_self'" class="preview-link-content preview-hover" :class="{ 'height-80': props.showName }" @click.stop="openPreview()">
        <qf-icon-pdf :style="props.iconStyle" />
      </jw-link>
      <!--不可预览的文件 -->
      <template v-else>
        <jw-link :href="setUrl(getFileItem, 0)" @click="checkInvalidUrl(getFileItem)" :title="getFileItem?.name" target="_blank" class="preview-link-content preview-hover" :class="{ 'height-80': props.showName }">
          <qf-icon-excel v-if="fileType('xlsx')" :style="props.iconStyle" />
          <qf-icon-word v-else-if="fileType('docs')" :style="props.iconStyle" />
          <qf-icon-zip v-else-if="fileType('zip')" :style="props.iconStyle" />
          <qf-icon-ppt v-else-if="fileType('ppt')" :style="props.iconStyle" />
          <!-- 无法预览的图片类型 -->
          <qf-icon-img v-else-if="fileType('unableImg')" :style="props.iconStyle" />
          <!-- 不可预览的视频类型 -->
          <qf-icon-video v-else-if="fileType('unableVideo')" :style="props.iconStyle" />
          <!-- 其他文件类型 -->
          <qf-icon-file v-else :style="props.iconStyle" />
        </jw-link>
      </template>
    </template>
    <p class="preview-name" v-if="props.showName">
      <jw-tooltip :content="getFileItem?.name || $t('暂无')">
        <span class="preview-name-text">{{ getFileItem?.name || $t('暂无') }}</span>
      </jw-tooltip>
    </p>
  </div>
  <template v-if="visible">
    <fh-preview-modal ref="previewModalRef" :index="props.index" :list="props.list" :active-file="getFileItem" />
  </template>
</template>
<script setup>
import { computed, ref, nextTick } from 'vue';
import useXlUpload from '@/hooks/upload';
const { setUrl, getFileSuffix, checkInvalidUrl, getFileType } = useXlUpload();
import { useGrayscaleStore } from '@/store';
const { grayList } = useGrayscaleStore();
const previewModalRef = ref(null);
const visible = ref(false);
const props = defineProps({
  fileItem: {
    //文件
    type: Object
  },
  showVideoCover: {
    type: Boolean,
    default: true
  },
  iconStyle: {
    type: Object,
    default: () => {
      return {
        width: '20px',
        height: '20px'
      };
    }
  },
  showName: {
    type: Boolean,
    default: true
  },
  index: {
    type: Number,
    default: 0
  },
  list: {
    type: Array,
    default: () => []
  }
});
const getFileItem = computed(() => {
  return props.fileItem;
});
// 文件类型判断
const fileType = (type) => {
  return getFileType(getFileItem.value?.name || '', type);
};

const openPreview = () => {
  // 众行互动不展示预览
  if (grayList?.['FilePreview:preview']) return;
  if (!checkInvalidUrl(getFileItem.value)) return;
  visible.value = true;
  nextTick(() => {
    previewModalRef.value?.openPreviewModal({
      index: props.index
    });
  });
};
</script>
<style scoped lang="less">
@import './fh-attachment-preview.less';
</style>
